// @flow
import {
    GET_PUSH_SERVICE_INFO,
    GET_PUSH_SERVICE_INFO_SUCCESS,
    GET_PUSH_SERVICE_INFO_FAILED,
    GET_UNREAD_NOTIFICATION,
    GET_UNREAD_NOTIFICATION_SUCCESS,
    GET_UNREAD_NOTIFICATION_FAILED,
    READ_NOTIFICATION,
    READ_NOTIFICATION_SUCCESS,
    READ_NOTIFICATION_FAILED
} from './constants';

const INIT_STATE = {
    pushServiceInfo: null,
    userEmail: null,
    entities: [],
    error: {},
    loading: false,
};

type State = {
    pushServiceInfo?: {} | null,
    userEmail?: String | null,
    entities?: [] | null,
    error?: {} | null,
    loading?: boolean
};

const Notification = (state: State = INIT_STATE, action: Action) => {
    switch (action.type) {
        case GET_PUSH_SERVICE_INFO:
            return {...state, loading: true};
        case GET_PUSH_SERVICE_INFO_SUCCESS:
            return {...state, pushServiceInfo: action.payload, loading: false, error: null};
        case GET_PUSH_SERVICE_INFO_FAILED:
            return {...state, error: action.payload, loading: false};
        case GET_UNREAD_NOTIFICATION:
            return {...state, loading: true};
        case GET_UNREAD_NOTIFICATION_SUCCESS:
            return {...state, entities: action.payload, loading: false, error: null};
        case GET_UNREAD_NOTIFICATION_FAILED:
            return {...state, error: action.payload, loading: false};
        case READ_NOTIFICATION:
            return {...state, loading: true};
        case READ_NOTIFICATION_SUCCESS:
            return {...state, loading: false, error: null};
        case READ_NOTIFICATION_FAILED:
            return {...state, error: action.payload, loading: false};
        default:
            return state;
    }
};

export default Notification;
